var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"edam-select\">\n  <div class=\"form-group\">\n    <input type=\"text\" class=\"form-control wrap-label\" placeholder=\"Label\" aria-label=\"Label\" value=\""
    + container.escapeExpression(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data}) : helper)))
    + "\">\n  </div>\n\n  <hr class=\"double-hr\">\n\n  <div>\n    <button class=\"unwrap\">Ungroup</button>\n  </div>\n\n  <hr>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/wrapper.hbs
// module id = 140
// module chunks = 0